var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStressNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_2552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9094 0 0 17.9094 0 40C0 62.0906 17.9094 80 40 80C62.0906 80 80 62.0906 80 40C80 17.9094 62.0906 0 40 0ZM20 30C20 27.2391 22.2391 25 25 25C27.7609 25 30 27.2391 30 30C30 32.7609 27.7609 35 25 35C22.2391 35 20 32.7609 20 30ZM57.675 57.675C52.9547 62.3953 46.6797 65 40 65C33.3203 65 27.0453 62.3953 22.3203 57.675C21.3453 56.7 21.3453 55.1156 22.3203 54.1406C23.2953 53.1656 24.8797 53.1656 25.8547 54.1406C33.4094 61.7 46.5797 61.7 54.1406 54.1406C55.1156 53.1656 56.7 53.1656 57.675 54.1406C58.65 55.1156 58.65 56.7 57.675 57.675ZM55 35C52.2391 35 50 32.7609 50 30C50 27.2391 52.2391 25 55 25C57.7609 25 60 27.2391 60 30C60 32.7609 57.7609 35 55 35Z",
    fill: "#64BD40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_2552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressNormal);
export default __webpack_public_path__ + "static/media/StressNormal.b77c7fa6bccf79739e6fc7934699c2e0.svg";
export { ForwardRef as ReactComponent };